import { Account } from "./../models/account";
import { AccountDataService } from "./../service/data/account-data.service";
import { BasicAuthenticationService } from "./../auth/basic-authentication.service";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"]
})
export class HeaderComponent implements OnInit {
  title = "Life Corporation Booking System";

  isCollapsed = true;

  isUserBanned = true;

  constructor(public basicAuthenticationService: BasicAuthenticationService, private accountDataService: AccountDataService) {
    this.basicAuthenticationService.isUserBanned.subscribe(value => {
      this.isUserBanned = value;
    });
  }

  async ngOnInit() {

    this.isCollapsed = true;

    let account: Account;

    // let today = new Date();

    // // this.accountDataService.getAccount(this.basicAuthenticationService.getAuthenticatedUser()).subscribe(
    // //   response => {
    // //     var firstKey = Object.keys(response)[0];

    // //     if (firstKey.toUpperCase() == "OK") {
    // //       account = response[firstKey];

    // //       let banExipryDate = new Date(account.banExpiryDate);

    // //       console.log("banExipryDate " + banExipryDate.toLocaleString());

    // //       if (banExipryDate > today) {
    // //         this.accountIsBanned = true;
    // //       } else {
    // //         this.accountIsBanned = false;
    // //       }
    // //     } else {
    // //     }
    // //   },
    // //   error => {}
    // // );

    // var response = await this.getAccount(this.basicAuthenticationService.getAuthenticatedUser());

    // var firstKey = Object.keys(response)[0];

    // if (firstKey.toUpperCase() == "OK") {
    //   account = response[firstKey];

    //   let banExipryDate = new Date(account.banExpiryDate);

    //   if (banExipryDate > today) {
    //     this.accountIsBanned = true;
    //   } else {
    //     this.accountIsBanned = false;
    //   }
    // }
  }

  // public getAccount(accountId: string): Promise<any> {
  //   console.log("getAccount ");

  //   return this.accountDataService.getAccount(this.basicAuthenticationService.getAuthenticatedUser()).toPromise();
  // }

  onLogout() {
    this.isCollapsed = true;
    this.basicAuthenticationService.logout();
  }
}
